// Module
var code = `<tft-select class="office-list-select" value="officeListCtrl.selectedOffice" options="officeListCtrl.officeListOptions" on-option-select="officeListCtrl.onOfficeChange(option)"> </tft-select> `;
// Exports
export default code;